<template>
<div>
    <v-text-field
        label="Organization Name"
        v-model="profile.organization_account.label"
        disabled
        autocomplete="off"
    />

     <v-text-field
        label="Username"
        v-model="profile.employee_account.username"
        disabled
        autocomplete="off"
    >

        <v-icon
            slot="append-outer"
            v-on:click="editUsername"
            color="primary"
            style="pointer-events: auto;"
            v-show="can_write"
        >
            mdi-lead-pencil
        </v-icon>

    </v-text-field>

    <p
        style="font-weight: bold; color: red"
    >
        {{username_used_in_other_orgs}}
    </p>



    <v-text-field
        label="Timezone"
        v-model="profile.employee_account.time_zone"
        disabled
        autocomplete="off"
    >

        <v-icon
            slot="append-outer"
            v-on:click="onStartEditTimezone"
            color="primary"
            style="pointer-events: auto;"
            v-show="can_write"
        >
            mdi-lead-pencil
        </v-icon>

    </v-text-field>

    <v-text-field
        label="Is Organization Administrator"
        :value="profile.employee_account.is_organization_admin ? 'Yes' : 'No'"
        disabled
        autocomplete="off"
    >

        <v-icon
            slot="append-outer"
            v-on:click="toggleOrganizationAdmin"
            color="primary"
            style="pointer-events: auto;"
            v-show="can_write && profile.actor_permissions.is_organization_admin"
        >
            mdi-lead-pencil
        </v-icon>

    </v-text-field>

     <m-restricted-field v-show="profile.actor_permissions.is_system_admin" >
        <v-text-field
            label="Is System Administrator"
            :value="profile.employee_account.is_system_admin ? 'Yes' : 'No'"
            disabled
            autocomplete="off"
        >
            <v-icon
                slot="append-outer"
                v-on:click="toggleSystemAdmin"
                color="primary"
                style="pointer-events: auto;"
                v-show="can_write && profile.actor_permissions.is_organization_admin"
            >
                mdi-lead-pencil
            </v-icon>

        </v-text-field>
    </m-restricted-field>

    <v-text-field
        label="Only Accept Incoming Calls from Known Numbers"
        :value="profile.employee_account.only_accept_incoming_phone_calls_from_known_numbers ? 'Yes' : 'No'"
        disabled
        autocomplete="off"
    >
        <v-icon
            slot="append-outer"
            v-on:click="toggleOnlyAcceptIncomingCallsFromKnownNumbers"
            color="primary"
            style="pointer-events: auto;"
        >
            mdi-lead-pencil
        </v-icon>

    </v-text-field>

    <v-text-field
        label="Payment Permissions"
        :value="prettyPrintPaymentPermissions(profile.employee_account.payment_permissions)"
        disabled
        autocomplete="off"
    >

        <v-icon
            slot="append-outer"
            v-on:click="onSetPaymentPermissions"
            color="primary"
            style="pointer-events: auto;"
            v-show="can_write && profile.actor_permissions.is_organization_admin"
        >
            mdi-lead-pencil
        </v-icon>

    </v-text-field>


    <m-display-text
        label="Organization Id"
        v-model="profile.employee_account.organization_id"
    />

    <m-display-text
        label="Employee Id"
        v-model="profile.employee_account.employee_id"
    />

    <m-edit-timezone-dialog
        ref="edit_timezone_dialog"
        v-on:ok="onChangeTimezone"
    />

    <v-text-field
        label="EULA Signature"
        :value="eula_signature"
        disabled
        autocomplete="off"
    >

        <v-icon
            slot="append-outer"
            v-on:click="onViewEulaDetail"
            color="primary"
            style="pointer-events: auto;"
        >
            mdi-information-outline
        </v-icon>

    </v-text-field>

    <m-edit-text
        label="Text Signature"
        hint="This will be appended to every text that you send.  Use of a text signature is **not** recommended."
        v-model="profile.employee_account.text_signature"
        v-on:input="onChangeTextSignature"
        optional
    />

    <m-eula-view-dialog
        ref="m-eula-view-dialog"
    />

    <m-employee-payment-permissions-dialog
        ref="employee-payment-permissions-dialog"
        v-on:patch-employee="onPatchEmployee"
    />

    <div style="text-align: right; ">
        <m-restricted-button
            v-on:click='onClickAlertDeliveryPreferences'
            v-if="$rc.$state.isSystemAdmin()"
            style="margin-right: 15px"
            
        >
            Alert Delivery Preferences
        </m-restricted-button>
        <v-btn
            v-on:click="onClickResetDismissedWarnings()"
            style="margin-right: 15px"
        >
            Reset Dismissed Warnings...
        </v-btn>

        <v-btn
            v-on:click="onClickWelcomeScreen()"
        >
            Welcome Screeen...
        </v-btn>

         <v-btn
            v-if="$rc.$state.hasExplicitHideSignInAsFooter()"
            v-on:click="onClickShowSignInFooter()"
            style="margin-left: 15px"
        >
            Show sign in as footer bar...
        </v-btn>

    </div>

</div>
</template>

<script>

const Validation = require('@/js/validate.js');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    methods: {

        editUsername()
        {
            this.$rc.prompt({
                'title' : 'Change Username',
                'text' : 'Only change a username if the individual\'s email address has actually changed; common examples include name changes due to marriage or correcting a typo. If you are replacing a team member with a new hire, you should archive this user and create a new user instead. \n',
                'label' : 'Enter new username',
                'value' : this.profile.employee_account.username,
                'after_prompt' : (value) => {
                    let changes = {
                        'username' : value,
                    };

                    this.$emit('patch-employee-account',changes);
                    this.$rc.snackbar('Username has been updated',3500);
                },

                'is_valid' : (value) => {
                    if ( value == null ) return false;
                    if ( !Validation.isEmailAddress(value) ) return false;
                    return true;
                }
            });
        },

        onClickWelcomeScreen()
        {
            this.$router.push({
                'name': 'welcome_ordinary_user',
                'params' : {
                    'employee_id': this.$route.params.employee_id,
                }
            });
        },

        onChangeTextSignature(value)
        {
            let changes = {
                'text_signature' : value,
            };

            this.$emit('patch-employee-account',changes);
        },

        editTimezone()
        {

        },

        toggleOrganizationAdmin()
        {
            let confirm_message;

            let username = this.profile.employee_account.username;

            if ( this.profile.employee_account.is_organization_admin )
                confirm_message = "Demote "+username+" to an ordinary user?"
            else
                confirm_message = "Promote "+username+" to an organization administrator?"

            if ( !confirm( confirm_message ) )
                return;

            let changes = {
                'is_organization_admin' : !this.profile.employee_account.is_organization_admin,
            };

            this.$emit('patch-employee-account',changes);
        },

        toggleSystemAdmin()
        {
            let confirm_message;

            let username = this.profile.employee_account.username;

            if ( this.profile.employee_account.is_organization_admin )
                confirm_message = "Demote "+username+" to an ordinary user?"
            else
                confirm_message = "Promote "+username+" to a system administrator?"

            if ( !confirm( confirm_message ) )
                return;

            let changes = {
                'is_system_admin' : !this.profile.employee_account.is_system_admin,
            };

            this.$emit('patch-employee-account',changes);
        },

        toggleOnlyAcceptIncomingCallsFromKnownNumbers()
        {
            let confirm_message;

            if ( this.profile.employee_account.only_accept_incoming_phone_calls_from_known_numbers )
            {
                confirm_message = "Allow any phone calls? This may include some spam calls."
            }
            else
            {
                confirm_message = "Allow only incoming phone calls from known numbers? A number is \"known\" if <b>any user</b>" +
                    " in your organization has done the following with it:<br>" +
                    "<ul>" +
                        "<li>Sent a text</li>" +
                        "<li>Received a text</li>" +
                        "<li>Made an outgoing call</li>" +
                        "<li>Saved a contact</li>" +
                        "<li>Created a curbside pickup</li>" +
                        "<li>Requested a payment</li>" +
                    "</ul>";
            }

            this.$rc.confirm(
                "Change Status",
                confirm_message,
                [
                    {'text' : 'Cancel', 'value' : 'cancel' },
                    {'text' : 'Confirm', 'value' : 'confirm' },
                ],
                (response) => {
                    if ( response != 'confirm' ) return;
                    let changes = {
                        'only_accept_incoming_phone_calls_from_known_numbers' : !this.profile.employee_account.only_accept_incoming_phone_calls_from_known_numbers,
                    };

                    this.$emit('patch-employee-account',changes);
                }
            );
        },

        onStartEditTimezone()
        {
            this.$refs['edit_timezone_dialog'].showDialog(this.profile);
        },

        onChangeTimezone(new_timezone)
        {
            let changes = {
                'time_zone' : new_timezone,
            };

            this.$emit('patch-employee-account',changes);
        },

        onViewEulaDetail()
        {
            this.$refs['m-eula-view-dialog'].showDialog(this.profile.employee_account.employee_id);
        },

        prettyPrintPaymentPermissions(permissions)
        {
            if ( permissions == 'no-access' ) return 'No Access';
            if ( permissions == 'request-and-process' ) return 'Request and Process All Payments';
            if ( permissions == 'request-and-self-process' )  return 'Request and Process Your Own Payments';
            if ( permissions == 'request-only' ) return 'Request Only';
        },

        onSetPaymentPermissions()
        {
            if ( this.profile.employee_account.is_organization_admin )
            {
                this.$rc.alert('Unable to set payment permissions', 'You can not change payment permissions for organization adminsitrations (must be able to both request and process)');
                return;
            }

            this.$refs['employee-payment-permissions-dialog'].showDialog({
                'payment_permissions' : this.profile.employee_account.payment_permissions,
                'employee_id' : this.profile.employee_account.employee_id,
            });

        },

        onPatchEmployee(changes)
        {
            this.$emit('patch-employee-account', changes);
        },

        clickGetIOSApp()
        {
            this.$router.push({
                'name': 'ios-to-instructions',
            }).catch(e=>{}); // swallow any exception
        },

        onClickResetDismissedWarnings()
        {
            this.$rc.$state.resetDismissedWarnings();

            this.$rc.snackbar('All dismissable warnings have been reset');
        },

        onClickAlertDeliveryPreferences()
        {
            this.$router.push({
                'name': 'alert-delivery-preferences',
                'params' : {
                    'employee_id': this.$route.params.employee_id,
                }
            });
        },

        onClickShowSignInFooter()
        {
            this.$rc.$state.clearHideSignInAsFooter();
            window.location.reload();
        },
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write;
        },

        alert_sound_label()
        {
            let ret = this.profile.extended_data.alert_sound_label;

            if ( ret == null )
                ret = 'No sound will play';

            return ret;
        },

        eula_signature()
        {
            let eula_check = this.profile.eula_check;

            if ( eula_check.latest_signature == null )
                return 'EULA not signed';

            return new Date(eula_check.latest_signature.signed_time) + ' (Version '+eula_check.latest_signed_packet.version+')';
        },

        username_used_in_other_orgs()
        {
            if ( this.profile.username_used_in_other_orgs.length == 0 )
                return null;

            return this.profile.employee_account.username + ' is also a user in '+this.$rc.pretty(this.profile.username_used_in_other_orgs,'comma_and_list');
        },

    },
}
</script>

<style lang="scss" scoped>
</style>